module.exports = __webpack_public_path__ + "img/icon.af88039c.png";